/**
 * Usuário pode transferir tickets (admin sempre; demais conforme permissão).
 */
const canTransferTicket = (user) => {
  if (!user) {
    return false;
  }

  if (user.profile === "admin") {
    return true;
  }

  return (user.allowTransferTicket || "enabled") !== "disabled";
};

export default canTransferTicket;
